import React from 'react';
import { SearchIcon, BarChartIcon, MessageCircleIcon, FileTextIcon, CameraIcon, LandmarkIcon } from 'lucide-react';
export const Process = () => {
  return <section id="como-funciona" className="py-10 sm:py-24 bg-white border-t border-gray-100" data-id="element-194">
      <div className="max-w-6xl mx-auto px-3 sm:px-6 lg:px-8 text-center" data-id="element-195">
        <h2 className="text-sm font-semibold text-blue-600 tracking-wide uppercase" data-id="element-196">
          Servicios
        </h2>
        <p className="mt-1 text-xl sm:text-3xl font-extrabold text-gray-900" data-id="element-197">
          Todo lo que necesitas para vender bien
        </p>
        <p className="mt-2 max-w-2xl text-sm sm:text-lg text-gray-500 mx-auto" data-id="element-198">
          Proceso digital, carpeta legal completa y marketing de alto impacto.
        </p>
      </div>
      {/* Scroll horizontal en mobile, grid en desktop */}
      <div className="mt-6 sm:mt-16 px-3 sm:px-0" data-id="element-199">
        <div className="overflow-x-auto scrollbar-hide -mx-3 px-3 sm:mx-0 sm:px-0" data-id="element-200">
          <div className="flex gap-3 sm:grid sm:grid-cols-3 sm:gap-8 max-w-5xl mx-auto min-w-max sm:min-w-0" data-id="element-201">
            <div className="text-center bg-white rounded-lg shadow-sm p-4 border border-gray-50 flex-shrink-0 w-72 sm:w-auto" data-id="element-202">
              <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-3" data-id="element-203">
                <MessageCircleIcon className="h-5 w-5 text-blue-600" data-id="element-204" />
              </div>
              <h3 className="text-base font-semibold text-gray-900" data-id="element-205">
                Plan de venta
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-206">
                Estrategia, pricing y calendarización. Menos visitas, más
                efectivas.
              </p>
            </div>
            <div className="text-center bg-white rounded-lg shadow-sm p-4 border border-gray-50 flex-shrink-0 w-72 sm:w-auto" data-id="element-207">
              <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-3" data-id="element-208">
                <SearchIcon className="h-5 w-5 text-blue-600" data-id="element-209" />
              </div>
              <h3 className="text-base font-semibold text-gray-900" data-id="element-210">
                Red y canje
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-211">
                Un solo corredor líder, abiertos a canje con toda la red para
                maximizar alcance.
              </p>
            </div>
            <div className="text-center bg-white rounded-lg shadow-sm p-4 border border-gray-50 flex-shrink-0 w-72 sm:w-auto" data-id="element-212">
              <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-3" data-id="element-213">
                <BarChartIcon className="h-5 w-5 text-blue-600" data-id="element-214" />
              </div>
              <h3 className="text-base font-semibold text-gray-900" data-id="element-215">
                Tasación 3 fuentes
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-216">
                Cruzamos datos de 3 entidades líderes para definir el mejor
                precio.
              </p>
            </div>
            <div className="text-center bg-white rounded-lg shadow-sm p-4 border border-gray-50 flex-shrink-0 w-72 sm:w-auto" data-id="element-217">
              <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-3" data-id="element-218">
                <CameraIcon className="h-5 w-5 text-blue-600" data-id="element-219" />
              </div>
              <h3 className="text-base font-semibold text-gray-900" data-id="element-220">
                Marketing pro
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-221">
                Fotos profesionales, tour virtual y plano para destacar tu
                propiedad.
              </p>
            </div>
            <div className="text-center bg-white rounded-lg shadow-sm p-4 border border-gray-50 flex-shrink-0 w-72 sm:w-auto" data-id="element-222">
              <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-3" data-id="element-223">
                <FileTextIcon className="h-5 w-5 text-blue-600" data-id="element-224" />
              </div>
              <h3 className="text-base font-semibold text-gray-900" data-id="element-225">
                Carpeta legal/municipal
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-226">
                Reunimos y ordenamos todo online para acelerar promesas y
                escritura.
              </p>
            </div>
            <div className="text-center bg-white rounded-lg shadow-sm p-4 border border-gray-50 flex-shrink-0 w-72 sm:w-auto" data-id="element-227">
              <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-3" data-id="element-228">
                <LandmarkIcon className="h-5 w-5 text-blue-600" data-id="element-229" />
              </div>
              <h3 className="text-base font-semibold text-gray-900" data-id="element-230">
                Negociación y cierre
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-231">
                Filtrado financiero, negociación guiada y acompañamiento hasta
                la firma.
              </p>
            </div>
          </div>
        </div>
        {/* Indicador de scroll en mobile */}
        <div className="mt-4 text-center sm:hidden" data-id="element-232">
          <p className="text-xs text-gray-400" data-id="element-233">← Desliza para ver más →</p>
        </div>
      </div>
    </section>;
};